import { render, staticRenderFns } from "./EditDriveFile.vue?vue&type=template&id=60664b4c&scoped=true&lang=pug"
import script from "./EditDriveFile.vue?vue&type=script&lang=js"
export * from "./EditDriveFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60664b4c",
  null
  
)

export default component.exports